import { CountUp } from 'countup.js'

export default function ItemCounter () {
  const elements = document.querySelectorAll('.countup-number')
  const items = []

  if (elements.length) {
    for (let i = 0; i < elements.length; i++) {
      const ITEM = {
        element: elements[i],
        started: false
      }
      items.push(ITEM)
    }
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        let num = item.element.innerHTML
        let hasComma = false
        let hasDecimal = false

        if (num.indexOf(',') !== -1) {
          num = num.replace(/,/g, '')
          hasComma = true
        }

        if (num.indexOf('.') !== -1) {
          hasDecimal = true
        }

        item.started = setupCounter(item.element, num, hasComma, hasDecimal)
        window.addEventListener('scroll', () => {
          if (!item.started) {
            item.started = !!setupCounter(item.element, num, hasComma, hasDecimal)
          }
        })
      }
    }
  }
}

function setupCounter (element, number, hasComma = false, hasDecimal = false) {
  element.style.width = element.getBoundingClientRect().width + 'px'
  if (inViewport(element)) {
    const COUNTER = new CountUp(element, number, {
      separator: hasComma ? ',' : '',
      decimal: hasDecimal ? '.' : '',
      decimalPlaces: hasDecimal ? 1 : 0
    })
    !COUNTER.error ? COUNTER.start(() => { element.style.width = '' }) : console.error(COUNTER.error)
    return true
  }
  return false
}

function inViewport (el) {
  if (!el) return false

  const BOUNDING = el.getBoundingClientRect()

  if (
    BOUNDING.top >= 0 &&
    BOUNDING.left >= 0 &&
    BOUNDING.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    BOUNDING.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
    return true
  }

  return false
}
